<template>
  <div class="bottom_area">
    <div
      class="firstItem"
      v-show="middleItems&&middleItems.length>5"
      @click="move('left')"
      @mouseenter="hoverStart('firstItem')"
      @mouseleave="hoverEnd('firstItem')"
    >
      <img :src="jt_left_url" alt class="arrow" />
    </div>
    <ul class="middleItems">
      <li
        v-for="(item,index) in middleItems"
        :key="item.id"
        :style="item.isHover == true?item.activeStyle : item.normalStyle"
        :title="item.name"
        @click="select(index,item,middleItems)"
        @mouseenter="mouseenter(index)"
        @mouseleave="mouseleave(index)"
      >
        <div class="item_content">
          <img :src="base_url().img_baseurl+item.ChapterThemeImg.visitimg" alt="">
          <div class="text">{{item.name}}</div>
        </div>
      </li>
    </ul>
    <div
      class="lastItem"
      v-show="middleItems&&middleItems.length>5"
      @click="move('right')"
      @mouseenter="hoverStart('lastItem')"
      @mouseleave="hoverEnd('lastItem')"
    >
      <img :src="jt_right_url" alt class="arrow" />
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
export default {
  name: "pcBottomArea",
  props: {
    middleItems: Array
  },
  data() {
    return {
      jt_left_url: "/images/jt_left1.png",
      jt_right_url: "/images/jt_right1.png",
      initchapterData: [],
      $version:0
    };
  },
  created() {
    this.$version = this.$version;
    this.jt_left_url+='?v='+this.$version;
    this.jt_right_url+='?v='+this.$version;
    //取出来最原始的的chapterData
    this.initchapterData = JSON.parse(
      window.sessionStorage.getItem("initchapterData")
    );
  },
  methods: {
    move(direction) {
      this.initchapterData = JSON.parse(
        window.sessionStorage.getItem("initchapterData")
      );
      if (this.middleItems.length > 5) {
        let firstItem = this.middleItems[0];
        let lastItem = this.middleItems[this.middleItems.length - 1];
        if (direction == "left") {
          if (firstItem.id == this.initchapterData[0].id) {
            this.$layer.msg("到第一个啦！");
            return;
          } else {
            this.middleItems.splice(this.middleItems.length - 1, 1);
            this.middleItems.unshift(lastItem);
          }
        } else {
          // 数组的第五个元素与初始元素id一样则到达最后一个
          if (
            this.middleItems[4].id ==
            this.initchapterData[this.initchapterData.length - 1].id
          ) {
            this.$layer.msg("到最后一个啦！");
            return;
          } else {
            this.middleItems.splice(0, 1);
            this.middleItems.push(firstItem);
          }
        }
      }
    },
    hoverStart(flag) {
      if (flag == "firstItem") {
        //图片变成深色的那个
        this.jt_left_url = "/images/jt_left.png";
      } else {
        //图片变成深色的那个
        this.jt_right_url = "/images/jt_right.png";
      }
    },
    hoverEnd(flag) {
      if (flag == "firstItem") {
        //图片变成浅色的那个
        this.jt_left_url = "/images/jt_left1.png";
      } else {
        //图片变成浅色的那个
        this.jt_right_url = "/images/jt_right1.png";
      }
    },
    select(index, item, middleItems) {
      for (let i = 0; i < this.middleItems.length; i++) {
        if (i == index) {
          this.middleItems[i].isActive = true;
        } else {
          this.middleItems[i].isActive = false;
        }
      }

      //判断是否有子章节，进行导航
      this.routerPush(item, middleItems);
    },
    mouseenter(index) {
      for (let i = 0; i < this.middleItems.length; i++) {
        if (i == index) {
          this.middleItems[i].isHover = true;
        } else {
          this.middleItems[i].isHover = false;
        }
      }
    },
    mouseleave(index) {
      for (let i = 0; i < this.middleItems.length; i++) {
        this.middleItems[i].isHover = false;
      }
    },
    routerPush(item, chapterList) {
      console.log(item.name);
      this.setGlobleTitle(item.name + " - " + this.globleTitle);
      //获取子章节页
      this.pathInfo.parentChapterLists.push(chapterList);
      if (item.ishaschildren) {
        //进入子章节页
        this.$router.push({
          path: "/SubChapter",
          query: { id: item.id, name: item.name }
        });
        this.getSubChapterData(item.id);
      } else {
        //存储当前章节数组的顺序，便于返回时还停留在当前章节
        window.sessionStorage.setItem(
          "activeChaperArraySort",
          JSON.stringify(this.middleItems)
        );
        this.$router.push({
          path: "/Content",
          query: { id: item.id, name: item.name }
        });
      }
    
      // document.getElementById("titleId").innerHTML =
      //   item.name + " - " + this.globleTitle;
      //存储章节列表，便于内容页匹配标题
      window.sessionStorage.setItem(
        "parentChapterLists",
        JSON.stringify(this.pathInfo.parentChapterLists)
      );
    },
    //获取子章节内容
    getSubChapterData(chapterId) {
      this.$emit("getSubChapter", chapterId);
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .bottom_area {
    display: none;
  }
}
.bottom_area {
  position: absolute;
  width: 100%;
  height: 150px;
  bottom: 0;
  text-align: center;
}
.bottom_area .firstItem {
  position: relative;
  width: 200px;
  height: 100%;
  float: left;
  background: #ffffff;
  cursor: pointer;
}
.bottom_area .lastItem {
  position: relative;
  width: 200px;
  height: 100%;
  float: right;
  background: #ffffff;
  cursor: pointer;
}
.bottom_area .arrow {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 16%;
  height: auto;
}
.bottom_area .middleItems {
  position: relative;
  width: calc(100% - 400px);
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
}

.bottom_area ul {
  width: 100%;
  text-align: center;
  display: inline-block;
}
.bottom_area li {
  position: relative;
  width: calc(20% - 1px);
  height: 100%;
  border-right: solid 1px #fff;
  text-align: center;
  top: 0;
  cursor: pointer;
  display: inline-block;
  text-align: center;
  border-radius: 10px 10px 0 0;
}
.bottom_area li .item_content {
  position: absolute;
  top: 50%;
  transform: translate3d(0, -50%, 0);
  left: 0;
  right: 0;
  margin: auto;
  white-space: pre-wrap;
  word-break: break-word;
}
.bottom_area li img{
  max-width: 20%;
  max-height: 70%;
}
.bottom_area li .iconfont {
  position: relative;
  margin: 0 auto;
  font-size: 60px;
}
.bottom_area li .text {
  position: relative;
  width: 80%;
  margin: 0 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
}
</style>